import { useState } from "react";
import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { contactInfo } from "../data/contactInfo";
import "../styles/Contact.scss";
const BASE_URL = "https://websiteserver-h47n.onrender.com/";
// const BASE_URL = "http://localhost:3000/";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      try {
        const response = await fetch(`${BASE_URL}sendEmail`, {
          method: "POST", // Specify the request method
          referrerPolicy: "origin",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...formData }), // Convert the data to JSON
        });

        // Check if the response is OK (status in the range 200-299)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the JSON response
        // const jsonResponse = await response.json();
        setFormData({ name: "", email: "", message: "" });
        setSubmitStatus("success");
        // return jsonResponse; // Return the parsed response
      } catch (error) {
        console.error("Error:", error); // Log any errors
        throw error; // Rethrow the error for further handling
      }
      // Replace with your form submission logic
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact">
      <div className="contact__hero">
        <h1>Get In Touch</h1>
        <p>{contactInfo.availability.status}.</p>
      </div>

      <div className="contact__container">
        <div className="contact__info">
          <h2>Contact Information</h2>
          <div className="contact__details">
            <div className="contact__detail">
              <FaEnvelope />
              <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
            </div>
            <div className="contact__detail">
              <FaMapMarkerAlt />
              <span>{contactInfo.location}</span>
            </div>
            {contactInfo.timezone && (
              <div className="contact__detail">
                <span>Timezone: {contactInfo.timezone}</span>
              </div>
            )}
            {contactInfo.responseTime && (
              <div className="contact__detail">
                <span>Response Time: {contactInfo.responseTime}</span>
              </div>
            )}
          </div>

          <div className="contact__social">
            <h3>Connect With Me</h3>
            <div className="contact__social-links">
              {contactInfo.social.github && (
                <a
                  href={contactInfo.social.github.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact__social-link"
                >
                  <FaGithub />
                  <span>GitHub</span>
                </a>
              )}
              {contactInfo.social.linkedin && (
                <a
                  href={contactInfo.social.linkedin.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact__social-link"
                >
                  <FaLinkedin />
                  <span>LinkedIn</span>
                </a>
              )}
            </div>
          </div>

          {contactInfo.languages && contactInfo.languages.length > 0 && (
            <div className="contact__languages">
              <h3>Languages</h3>
              <div className="contact__languages-list">
                {contactInfo.languages.map((language, index) => (
                  <span key={index} className="contact__language">
                    {language}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="contact__form-group">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Name"
            />
            <label>Name</label>
          </div>

          <div className="contact__form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Email"
            />
            <label>Email</label>
          </div>

          <div className="contact__form-group">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Message"
              rows="5"
            ></textarea>
            <label>Message</label>
          </div>

          <button
            type="submit"
            className={`contact__submit ${isSubmitting ? "submitting" : ""}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>

          {submitStatus && (
            <div className={`contact__status contact__status--${submitStatus}`}>
              {submitStatus === "success"
                ? "Message sent successfully!"
                : "Failed to send message. Please try again."}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
